import { DatePeriod } from "@/popups/dateTimePeriod"

export interface SearchCriteria {
  userGroupId?: string | undefined
  userId?: string | undefined
  machineId?: string | undefined
  search?: string | undefined
  period?: DatePeriod
}

export function SearchCriteriaParams(criteria: SearchCriteria) {
  const params = new URLSearchParams()

  const map: Record<string, unknown> = {
    usergroup: criteria.userGroupId,
    search: criteria.search,
    userId: criteria.userId,
    machineId: criteria.machineId,
    periodFor: criteria.period?.for
      ? new Date(criteria.period.for).toISOString()
      : undefined,
    periodLength: criteria.period?.length
  }

  for (const key in map) {
    const value = map[key]
    if (value !== undefined && value !== null && value !== "")
      params.append(key, String(value))
  }

  return params.toString()
}
